import { render } from "./SimulationContactForm.vue?vue&type=template&id=b226c65e&scoped=true&ts=true"
import script from "./SimulationContactForm.vue?vue&type=script&lang=ts"
export * from "./SimulationContactForm.vue?vue&type=script&lang=ts"

import "./SimulationContactForm.vue?vue&type=style&index=0&id=b226c65e&lang=scss&scoped=true"

import exportComponent from "/builds/Chirbou/isolation/client/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b226c65e"]])

export default __exports__